import { render, staticRenderFns } from "./backgroundSupply.vue?vue&type=template&id=2e99722e&"
import script from "./backgroundSupply.vue?vue&type=script&lang=js&"
export * from "./backgroundSupply.vue?vue&type=script&lang=js&"
import style0 from "./backgroundSupply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports